import { Link } from "react-router-dom";
import { IS_PROD_ENV } from "constants/environment";
import { Home, Info } from "@mui/icons-material";
import { getColorByEnv } from "utils/get-colors-by-env";

import {
  IconButton,
  Tooltip,
  Typography,
  Grid,
  Container,
  Breadcrumbs,
} from "@material-ui/core";


export default function HeaderClientes({
  section,
  subsection,
  tooltipMessage,
}) {
  return (
    <Container
      maxWidth={false}
      style={{ backgroundColor: getColorByEnv(), paddingBottom: "4.5rem" }}
    >
      <Grid container alignItems="center">
        <Typography variant="h2" component="h6" color="textSecondary">
          {section}
        </Typography>

        {tooltipMessage && (
          <Tooltip title={tooltipMessage} arrow>
            <IconButton color="secondary" style={{ padding: "0.5rem" }}>
              <Info />
            </IconButton>
          </Tooltip>
        )}

        <Breadcrumbs
          separator="-"
          aria-label="breadcrumb"
          style={{ marginLeft: "1rem" }}
        >
          <Link color="inherit" to="/home">
            <Home fontSize="small" />
          </Link>
          <Link color="primary" to="/" onClick={(e) => e.preventDefault()}>
            {subsection}
          </Link>
          <Typography color={IS_PROD_ENV ? "secondary" : "primary"}>
            {section}
          </Typography>
        </Breadcrumbs>
      </Grid>
    </Container>
  );
}
